/**
 * Line icons of the match UI (docs/design/ui-style.md): 24×24 paths,
 * stroked with currentColor so they take the text colour of their place.
 */
const PATHS = {
  race: '<path d="M5 21V4h11l-2 4 2 4H5"/>',
  players:
    '<circle cx="9" cy="8" r="3"/><path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6"/><path d="M16 5.3a3 3 0 0 1 0 5.4M18 14.6c1.8.9 3 2.9 3 5.4"/>',
  left: '<path d="M14 6l-6 6 6 6"/>',
  right: '<path d="M10 6l6 6-6 6"/>',
  log: '<path d="M5 6h14M5 12h14M5 18h9"/>',
  crisis:
    '<circle cx="12" cy="12" r="4"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9 7 7M17 17l2.1 2.1M4.9 19.1 7 17M17 7l2.1-2.1"/>',
  shield: '<path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z"/>',
  war: '<path d="M4 4l9 9M20 4l-9 9M7 17l-3 3M17 17l3 3M9.5 14.5l-3 3M14.5 14.5l3 3"/>',
  lock: '<rect x="5" y="11" width="14" height="9"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/>',
  ban: '<circle cx="12" cy="12" r="8"/><path d="M6.5 6.5l11 11"/>',
  coin: '<circle cx="12" cy="12" r="8"/><path d="M9 9.5c0-1.4 1.3-2 3-2s3 .8 3 2-1.3 1.7-3 2.2-3 1-3 2.3 1.3 2 3 2 3-.6 3-2M12 5.5v2M12 16.5v2"/>',
  flag: '<path d="M5 21V4h11l-2 4 2 4H5"/>',
  research:
    '<path d="M9 3h6M10 3v6l-5 9a2 2 0 0 0 1.7 3h10.6a2 2 0 0 0 1.7-3l-5-9V3"/><path d="M7.5 15h9"/>',
  build: '<path d="M3 21h18M6 21V10l6-4 6 4v11M10 21v-5h4v5"/>',
  ship: '<path d="M12 3l7 17-7-4-7 4z"/>',
  pirates: '<circle cx="12" cy="10" r="6"/><path d="M9 21v-4M15 21v-4M9.5 9.5h.01M14.5 9.5h.01"/>',
  market: '<path d="M3 20h18M5 16l4-5 4 3 6-8"/><path d="M15 6h4v4"/>',
  planet:
    '<circle cx="12" cy="12" r="5.5"/><ellipse cx="12" cy="12" rx="10.5" ry="3.2" transform="rotate(-20 12 12)"/>',
  warn: '<path d="M12 3l10 18H2z"/><path d="M12 10v5M12 18h.01"/>',
  stop: '<rect x="7" y="7" width="10" height="10"/>',
  home: '<path d="M4 11l8-7 8 7v9H4z"/><path d="M10 20v-5h4v5"/>',
  scan: '<circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="3"/><path d="M12 12l6-6"/>',
  cloud: '<path d="M7 18h10a4 4 0 0 0 .5-8 6 6 0 0 0-11.4 1.5A3.3 3.3 0 0 0 7 18z"/>',
  info: '<circle cx="12" cy="12" r="9"/><path d="M12 11v6M12 7.5h.01"/>',
} as const;

export type IconName = keyof typeof PATHS;

export const icon = (name: IconName, size = 20): string =>
  `<svg class="sd-icon" width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${PATHS[name]}</svg>`;
